import { DataSourceCodes } from '../Models/Constants';

export const shouldUseNewImport = (code: DataSourceCodes): boolean =>
    [
        DataSourceCodes.Excel,
        DataSourceCodes.ExcelDesktop,
        DataSourceCodes.ExcelPersonalWealth,
        DataSourceCodes.QuickBooks,
        DataSourceCodes.Xero,
        DataSourceCodes.XeroPracticeManager,
        DataSourceCodes.GoogleSheets,
        DataSourceCodes.SageIntacct,
    ].includes(code);

/**
 * Takes a progress percent and the previous progress percent and returns a smoothed value so progress doesn't jump significantly
 */
export const getSmoothProgress = (pct: number, prevPct: number): number => {
    const smoothVal = 3;
    const oldPct = prevPct || pct;

    if ((pct !== oldPct || pct - oldPct > smoothVal) && !(oldPct + smoothVal > pct)) {
        // Smoothing
        if (pct - oldPct > 4 * smoothVal) {
            pct = oldPct + 2 * smoothVal;
        } else {
            pct = oldPct + smoothVal;
        }
    }

    if (pct > 100) {
        // Max 100%
        pct = 100;
    }

    pct = Math.max(pct, 10); // Always > 10
    pct = Math.max(prevPct, pct); // Always grow
    return pct;
};

export const isDesktop = (code: DataSourceCodes): boolean =>
    [
        DataSourceCodes.MYOBAccountRightDesktop,
        DataSourceCodes.QuickBooksDesktop,
        DataSourceCodes.Sage50Desktop,
    ].includes(code);

export const calculateProgress = ({
    code,
    lastProgress,
    completedWork,
    importedReports,
    startedOrganisations,
    totalReports,
    totalOrganisations,
}: {
    code: DataSourceCodes;
    lastProgress: number;
    completedWork: number;
    importedReports: number;
    startedOrganisations: number;
    totalReports: number;
    totalOrganisations: number;
}): number => {
    const getProgressLessDesktopFile = (pct) => {
        if (isDesktop(code)) {
            // Uploading the desktop file is worth 50% of the progress, we need to scale 100 into 50%
            pct = 50 + pct / 2;
        }
        return pct;
    };

    if (shouldUseNewImport(code)) {
        if (completedWork > 1) {
            let nextProgress = getProgressLessDesktopFile(completedWork);
            nextProgress = getSmoothProgress(nextProgress, lastProgress);
            return nextProgress;
        }
        return 0;
    } else {
        if (totalReports > 1) {
            const pct = Math.floor(
                ((importedReports * startedOrganisations) / totalReports / totalOrganisations) * 100,
            );
            let nextProgress = getProgressLessDesktopFile(pct);
            nextProgress = getSmoothProgress(nextProgress, lastProgress);
            return nextProgress;
        }
        return 0;
    }
};
